import { loadPyodide } from 'pyodide';

export async function initializePyodide() {
    const pyodide = await loadPyodide({
        indexURL: 'https://cdn.jsdelivr.net/pyodide/v0.23.4/full/',
    });
    return pyodide;
}

// FIXME run python scripts in a serperate worker to interupt in case of excceeded timeout
export async function runPythonScript(pyodide, code) {
    await pyodide.runPythonAsync(`
        import sys
        import io
        sys.stdout = io.StringIO()
    `);
    await pyodide.loadPackage("sqlite3")
    
    try {
        // eslint-disable-next-line no-unused-vars
        let compiledCode = pyodide.runPython(code);
        let showOutput = pyodide.runPython('sys.stdout.getvalue()');
        return showOutput;
    } catch (error) {
        return error.message;
    }
}
